/*
    Cart template component
*/

import { app } from '../app.js';

export default {
    computed: {
        // We need to pass through the vars here for reasons 
        // I can't remember, but if these get removed it falls apart
        cart() {
            return app.cart;
        },
        cartProducts() {
            return app.cartProducts;
        },
        isCartLoading() {
            return app.isCartLoading;
        },
        cartMessage() {
            return app.cartMessage;
        }
    },
    methods: {
        filterLineItemProperties(data) {
            return app.filterLineItemProperties(data);
        },
        filterLineItemPrices(data) {
            return app.filterLineItemPrices(data);
        },
        addProduct(item) {
            return app.addProduct(item);
        },
        async removeProduct(item, quantity) {
            await app.removeProduct(item, quantity);

            const mainContentElement = document.querySelector('#MainContent');
            if (mainContentElement) mainContentElement.style.minHeight = 'auto';

            const cartItemsElement = document.querySelector('.cart__items');
            if (cartItemsElement) cartItemsElement.style.minHeight = 'auto';
        },
        findItemDiscountMessage(item) {
            return app.findItemDiscountMessage(item);
        }
    }
}